import { upperFirst } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'
import { NOTIFICATIONS_AVAILABLE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'
import { NOTIFICATIONS_TEMPLATES, NOTIFICATIONS_TEMPLATES_MANAGER } from '@sigma-legacy-libs/essentials/lib/schemas/notifications'

import render from './render'

const skipNotificationKeysRegExp = /^notifications\.(?:enabled|extraRecipients|events\.providers\.health\.recipients|(?:events\.billings|childrenUsersEvents\.balance)\.limit)$/

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    props: {
      settings: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },

    data() {
      return {
        path: undefined,
        showDialog: false
      }
    },

    computed: {
      schema() {
        const result = {
          keys: [],
          templates: {
            users: {},
            managers: {}
          }
        }

        for (const key in options.keys) {
          if (skipNotificationKeysRegExp.test(key)) {
            continue
          }
          const [ service, , component ] = key.split('.')
          if (service === Services.notifications) {
            switch (component) {
              case 'templates': {
                for (const type of NOTIFICATIONS_AVAILABLE_TYPES) {
                  result.templates.users[type] = Object.keys(NOTIFICATIONS_TEMPLATES).filter(template => {
                    return ~template.split('.').indexOf(type)
                  })
                  result.templates.managers[type] = Object.keys(NOTIFICATIONS_TEMPLATES_MANAGER).filter(template => {
                    return ~template.split('.').indexOf(type)
                  })
                }
                break
              }
              default: {
                result.keys.push(key)
                break
              }
            }
          }
        }

        return result
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
